import { Menu } from "./menu";
import { StringsKeys } from "core/internationalization/strings";
import DashboardNavigationLocations from "core/navigation/DashboardNavigationLocations";

const footerMenu: Menu = [
  {
    title: StringsKeys.administration,
    children: [
      {
        location: DashboardNavigationLocations.ROLES_AND_RIGHTS,
        title: StringsKeys.rolesAndRights,
        featurePermissions: ["READ_ROLES", "READ_PERMISSIONS_MATRIX"],
      },
      {
        location: DashboardNavigationLocations.RISK_ENTITY_REFERENTIAL,
        title: StringsKeys.riskEntityReferential,
        // TODO(perm-phase-2): add featurePermissions: ["COMPLIANCE_RISK_ENTITY_READ"]
      },
      {
        location: DashboardNavigationLocations.PLATFORM_SETTINGS,
        title: StringsKeys.platformSettings,
        roleLabels: ["BOX_AFRICA_ADMIN"],
      },
      {
        location: DashboardNavigationLocations.AGENCES,
        title: StringsKeys.agences,
        // Lecture ouverte a tout agent authentifie, aucune permission dediee (decision explicite).
      },
    ],
  },
];

export default footerMenu;
